module.exports = __webpack_public_path__ + "static/media/chalkboardLong.32fe8084.jpg";